/**
 * IM Time theme for MUI
 * TODO: create a theme object as per designs
 */
export default {
  palette: {
    primary: {
      //   light: "#33c9dc",
      main: "#1B75BC",
      dark: "#58595B",
      //   contrastText: "#fff", will be calculated to contrast with palette.primary.main
    },
    secondary: {
      //   light: "#ff6333",
      main: "#808080",
      //   dark: "#b22a00",
      //   contrastText: "#fff",
    },
    background: {
      default: "#f3f5f7",
    },
  },
  typography: {
    button: {
      // textTransform: "none",   //Using this will stop tranforming all button texts to UPPERCASE
    },
  },
  //common styles.
  white: "#fff",
  success: "#8DC13F",
  global: {
    textRight: {
      textAlign: "right",
    },
  },
  grey: "rgba(0, 0, 0, 0.5)",
  lightGrey: "rgba(0, 0, 0, 0.2)",
  space: {
    bottom: 20,
  },
  card: {
    margin: 20,
    padding: 20,
  },
};
